import { AppInsightsContext, ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { createBrowserHistory } from 'history';
import { ReactNode, useEffect, useState } from 'react';
import { EnvironmentType, useEnvironment } from '../hooks/useEnvironment';
import { useRoutePerformance } from '../hooks/useRoutePerformance';
import { getCurrentConfiguration } from '../services/session.service';

const reactPlugin = new ReactPlugin();

const initializeAppInsights = async () => {
  // TODO should probably be received from a .env file instead of over HTTP
  const config = await getCurrentConfiguration();

  const instance = new ApplicationInsights({
    config: {
      connectionString: config.applicationInsightsConnectionString!,
      extensions: [reactPlugin],
      extensionConfig: {
        [reactPlugin.identifier]: { history: createBrowserHistory() },
      },
    },
  });
  instance.loadAppInsights();
  return instance;
};

export function ApplicationInsightsContext({ children }: { children: ReactNode }) {
  const { environment } = useEnvironment();

  const [instance, setInstance] = useState<ApplicationInsights>();

  // Turn of AppInsights in local and undetected environments. We have also have to turn off in undetected because first time the app is loaded, the environment is undetected. This can be fixed with .env files instead
  const shouldNotInitialize = environment === EnvironmentType.Local;

  useEffect(() => {
    if (shouldNotInitialize) return;
    async function initializeAppInsightsAndRoutePerformance() {
      const instance = await initializeAppInsights();
      setInstance(instance);
    }

    initializeAppInsightsAndRoutePerformance();
  }, [shouldNotInitialize]);

  useRoutePerformance(instance);

  if (shouldNotInitialize) {
    return <>{children}</>;
  }

  return <AppInsightsContext.Provider value={reactPlugin}>{children}</AppInsightsContext.Provider>;
}
